import StaticStickitView from './static_stickit_view';

const updateDay = ($el, val) => {
  if (val) {
    $el.parent().addClass('active');
    $el.prop('checked', true);
  } else {
    $el.parent().removeClass('active');
    $el.prop('checked', false);
  }
};

export default StaticStickitView.extend({
  // A view for selecting the day of the week.  The view takes a Query as its
  // model, and the day of the week boxes are bound to its corresponding
  // day attributes
  bindings: {
    ':el': {
      observe: 'service_type',
      visible(val, options) {
        const serviceType = _.findWhere(Rover.serviceTypesJson, { slug: val });
        return serviceType && serviceType.supports_day_of_week_search;
      },
    },
    '.js-sunday': {
      observe: 'sunday',
      update: updateDay,
    },
    '.js-monday': {
      observe: 'monday',
      update: updateDay,
    },
    '.js-tuesday': {
      observe: 'tuesday',
      update: updateDay,
    },
    '.js-wednesday': {
      observe: 'wednesday',
      update: updateDay,
    },
    '.js-thursday': {
      observe: 'thursday',
      update: updateDay,
    },
    '.js-friday': {
      observe: 'friday',
      update: updateDay,
    },
    '.js-saturday': {
      observe: 'saturday',
      update: updateDay,
    },
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/day_of_the_week_picker_view.js